import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SentEnvelopeStatusCounter } from '../../model/sent-envelope-status-counter';
import { SentEnvelopeStatus } from 'src/app/enum/sent-envelope-status';
import { IDropdownTab } from 'codex-lib/lib/interface/dropdownTab.interface';

export interface ITab {
  badgeValue?: number;
  badgeClass?: string;
  title: string;
}

@Component({
  selector: 'app-sent-tabs',
  templateUrl: './sent-tabs.component.html',
  styleUrls: ['./sent-tabs.component.scss'],
})
export class SentTabsComponent implements OnInit {
  tabs: Array<ITab>;
  dropdown: IDropdownTab;

  private _statusCounter: SentEnvelopeStatusCounter;
  private selectedTabIndex: number | null = null;

  get statusCounter(): SentEnvelopeStatusCounter {
    return this._statusCounter;
  }

  @Input() set statusCounter(value: SentEnvelopeStatusCounter) {
    this.updateBadgeValues(value);
  }

  @Output() onChangeTab = new EventEmitter<SentEnvelopeStatus>();
  @Output() onTabClick = new EventEmitter<SentEnvelopeStatus>();

  constructor() {
    this.tabs = [
      {
        title: 'envelope.tabs.pending',
      },
      {
        title: 'envelope.tabs.toFill',
      },
      {
        title: 'envelope.tabs.onApproval',
      },
      {
        title: 'envelope.tabs.completed',
      },
      {
        title: 'envelope.tabs.expired',
      },
      {
        title: 'envelope.tabs.deleted',
      },
      {
        title: 'envelope.tabs.reproved',
      },
      {
        title: 'envelope.tabs.rejected'
      },
    ];
  }

  ngOnInit() {
    this.dropdown = {
      items: [
        {
          title: '',
        },
      ],
    };
  }

  tabSelect(tabIndex: number) {
    if (this.selectedTabIndex === tabIndex) {
      return;
    }

    const tabStatus = this.getStatusByTabIndex(tabIndex);

    if (!tabStatus) {
      return;
    }

    this.selectedTabIndex = tabIndex;
    this.onChangeTab.emit(tabStatus);
  }

  tabClick(tabIndex: number) {
    const tabStatus = this.getStatusByTabIndex(tabIndex);

    if (!tabStatus) {
      return;
    }

    this.onTabClick.emit(tabStatus);
  }

  private getStatusByTabIndex(tabIndex: number): SentEnvelopeStatus | null {
    switch (tabIndex) {
      case 0:
        return SentEnvelopeStatus.pending;
      case 1:
        return SentEnvelopeStatus.toFill;
      case 2:
        return SentEnvelopeStatus.onApproval;
      case 3:
        return SentEnvelopeStatus.completed;
      case 4:
        return SentEnvelopeStatus.expired;
      case 5:
        return SentEnvelopeStatus.deleted;
      case 6:
        return SentEnvelopeStatus.reproved;
      case 7:
        return SentEnvelopeStatus.rejected;
      default:
        return null;
    }
  }

  updateBadgeValues(counter: SentEnvelopeStatusCounter) {
    if (this.tabs !== undefined) {
      if (this.tabs.length > 0) {
        if (counter.pending && counter.pending > 0) {
          this.tabs[0].badgeClass = 'badge-tabs warning';
          this.tabs[0].badgeValue = counter.pending;
        } else {
          this.tabs[0].badgeClass = undefined;
          this.tabs[0].badgeValue = undefined;
        }
      }

      if (this.tabs.length > 1) {
        if (counter.toFill && counter.toFill > 0) {
          this.tabs[1].badgeClass = 'badge-tabs info';
          this.tabs[1].badgeValue = counter.toFill;
        } else {
          this.tabs[1].badgeClass = undefined;
          this.tabs[1].badgeValue = undefined;
        }
      }
      if (this.tabs.length > 2) {
        if (counter.onApproval && counter.onApproval > 0) {
          this.tabs[2].badgeClass = 'badge-tabs info';
          this.tabs[2].badgeValue = counter.onApproval;
        } else {
          this.tabs[2].badgeClass = undefined;
          this.tabs[2].badgeValue = undefined;
        }
      }
      if (this.tabs.length > 3) {
        if (counter.completed && counter.completed > 0) {
          this.tabs[3].badgeClass = 'badge-tabs success';
          this.tabs[3].badgeValue = counter.completed;
        } else {
          this.tabs[3].badgeClass = undefined;
          this.tabs[3].badgeValue = undefined;
        }
      }
      if (this.tabs.length > 4) {
        if (counter.expired && counter.expired > 0) {
          this.tabs[4].badgeClass = 'badge-tabs warning';
          this.tabs[4].badgeValue = counter.expired;
        } else {
          this.tabs[4].badgeClass = undefined;
          this.tabs[4].badgeValue = undefined;
        }
      }
      if (this.tabs.length > 5) {
        if (counter.deleted && counter.deleted > 0) {
          this.tabs[5].badgeClass = 'badge-tabs danger';
          this.tabs[5].badgeValue = counter.deleted;
        } else {
          this.tabs[5].badgeClass = undefined;
          this.tabs[5].badgeValue = undefined;
        }
      }
      if (this.tabs.length > 6) {
        if (counter.reproved && counter.reproved > 0) {
          this.tabs[6].badgeClass = 'badge-tabs danger';
          this.tabs[6].badgeValue = counter.reproved;
        } else {
          this.tabs[6].badgeClass = undefined;
          this.tabs[6].badgeValue = undefined;
        }
      }
      if (this.tabs.length > 7) {
        if (counter.rejected && counter.rejected > 0) {
          this.tabs[7].badgeClass = 'badge-tabs danger';
          this.tabs[7].badgeValue = counter.rejected;
        } else {
          this.tabs[7].badgeClass = undefined;
          this.tabs[7].badgeValue = undefined;
        }
      }
    }
  }
}
